import type { OnInit } from '@angular/core';
import { Component, HostBinding, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StickyHeaderService } from '@core-mkt/services/sticky-header/sticky-header.service';
import { SkipNavComponent } from '@core-mkt/shared/components/skip-nav/skip-nav/skip-nav.component';
import { cloneDeep } from 'lodash-es';

import type { Image } from '@core-mkt/interfaces/image';
import type { PageDataResponse } from '@core-mkt/resolvers/page-data/page-data-response';
import { DesktopMenuComponent } from '../desktop-menu/desktop-menu/desktop-menu.component';
import type { Menu } from './header';
import { newHeaderData } from './header-data';
import { stateList } from './state-nav-data';

@Component({
  selector: 'ace-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [SkipNavComponent, DesktopMenuComponent],
})
export class HeaderComponent implements OnInit {
  @HostBinding('class.sticky-header') headerSticky = false;
  private readonly stickyHeaderService = inject(StickyHeaderService);
  resolverData: PageDataResponse;
  hideNav = false;
  showDefaultNav = true;
  secondaryLogo: Image;
  menuData: Menu = {
    state: 'Select State',
    showInPersonLessons: false,
    slug: '',
    menuItems: newHeaderData.default.menuItems,
  };

  constructor(private route: ActivatedRoute) {
    if (this.route.snapshot) {
      this.resolverData = cloneDeep(this.route.snapshot.data.pageData) as PageDataResponse;
    }
  }

  ngOnInit(): void {
    // EPS-4465: DEC's nav pins on every page — `.simplified-nav` and the mobile
    // `.mh` bar are `position: sticky` unconditionally (CRO-1093 / EPS-4220),
    // independent of Craft's isNavSticky — so the countdown banner has to pin
    // above it. The `.sticky-header` host class below stays keyed to
    // isNavSticky: DEC owns its own sticky mechanics and z-order.
    this.stickyHeaderService.setSticky(true);
    if (this.resolverData && this.resolverData.craftData && this.resolverData.craftData?.headerData) {
      this.menuData.showInPersonLessons = this.resolverData.craftData.headerData.hasInPersonLessons;
      this.menuData.slug = this.resolverData.craftData.entryData.slug;
      this.hideNav = this.resolverData.craftData.headerData.hideNav;
      //needs to be added to the graphql query
      this.headerSticky = this.resolverData.craftData.headerData.isNavSticky;
      const additionalHeaderLogo = this.resolverData.craftData.headerData?.additionalHeaderLogo;
      if (additionalHeaderLogo && additionalHeaderLogo.length > 0) {
        this.secondaryLogo = additionalHeaderLogo[0];
      }
      if (this.resolverData.craftData.headerData?.pageState) {
        const stateData = stateList.find(
          (state) => state.href === `/${this.resolverData.craftData.headerData.pageState}/`,
        );
        this.menuData.state = stateData?.text || 'Select State';
        this.menuData.stateUrl = stateData?.href || '';
      }
    } else {
      this.menuData.state = 'Select State';
    }
    if (this.hideNav) {
      this.showDefaultNav = false;
    }
  }
}
